// Collects samples and hands them over as one array per flush, so a burst of
// WebSocket frames (many patients x several channels, or a backlog released
// when a throttled background tab wakes up) costs one store update instead of
// one per sample. flush() is also exposed for unmount/teardown.
//
// flushNow() is consulted on every push: when it returns true the buffer is
// handed over immediately. The CMS uses it while the tab is hidden, because
// browsers stretch timers in background tabs to 1s - 1min, and alerts must
// not wait on that (WebSocket messages themselves are not throttled).
export function createSampleBatcher(onFlush, intervalMs = 250, flushNow = () => false) {
    let buffer = [];
    let timer = null;

    const flush = () => {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        if (buffer.length === 0) return;
        const batch = buffer;
        buffer = [];
        onFlush(batch);
    };

    return {
        push(samples) {
            if (!samples || samples.length === 0) return;
            buffer.push(...samples);
            if (flushNow()) flush();
            else if (!timer) timer = setTimeout(flush, intervalMs);
        },
        flush,
        cancel() {
            if (timer) clearTimeout(timer);
            timer = null;
            buffer = [];
        },
    };
}
